export default "__VITE_ASSET__nkTEBNeQ__"